import {
  API_URL,
  validateAssessment,
  validateinterview,
} from '../../constants/apiUrls';
import { getRequest } from '../../services';

const preAssessmentCheckHelper = async (
  techId,
  setSnackbarOpen,
  isInterview
) => {
  try {
    if (!isInterview) {
      await getRequest(validateAssessment(techId));
    } else {
      await getRequest(validateinterview(isInterview));
    }
    const url = isInterview
      ? `${API_URL.PRE_ASSESSMENT_CHECK}?isInterview=${isInterview}`
      : `${API_URL.PRE_ASSESSMENT_CHECK}`;
    const response = await getRequest(url);
    return response;
  } catch (error) {
    setSnackbarOpen({
      setopen: true,
      message: error.msg,
      severity: 'error',
    });
    throw error;
  }
};

export default preAssessmentCheckHelper;
